/* eslint-disable no-prototype-builtins */
import React, { Component } from 'react'
import './loader.scss'

const LoaderHOC = propName => WrappedComponent => class LoaderHOC extends Component {
  isEmpty(prop) {
    return (
      prop === null
        || prop === undefined
        || (prop.mainContent
          && prop.mainContent.hasOwnProperty('length')
          && prop.mainContent.length === 0)
        || (prop.hasOwnProperty('length') && prop.length === 0)
        || (prop.constructor === Object && Object.keys(prop).length === 0)
    )
  }

  render() {
    return this.isEmpty(this.props[propName])
        || this.props[propName].isFetching ? (
          <div className="main-content">
            <div id="loading">
              <div className="animation">
                <div className="circle" />
                <div className="circle" />
                <div className="circle" />
                <div className="circle" />
              </div>
            </div>
          </div>
      ) : (
        <WrappedComponent {...this.props} />
      )
  }
}

export default LoaderHOC



// WEBPACK FOOTER //
// ./components/loader/index.js